import React, { useEffect, useState } from 'react';
import { Row, Col, Carousel } from 'react-bootstrap';
import { get } from '../../../services/apiController';
import { toast, ToastContainer } from 'react-toastify';
import { useParams } from 'react-router-dom';
import 'react-toastify/dist/ReactToastify.css';
import './OrderDisplay.css';
import Breadcrumb from '../../../components/Breadcrumb';
import OrderForm from '../components/OrderForm';
import { Link } from 'react-router-dom';

const OrderDisplay = () => {
  const { categoryId, subCategoryId, productId } = useParams();
  const [shapes, setShapes] = useState([]);
  const [flavours, setFlavours] = useState([]);
  const [product, setProduct] = useState();
  const [colorImages, setColorImages] = useState([]);

  useEffect(() => {
    get(`/cake/products/${productId}`)
      .then((res) => {
        const { data } = res;
        setProduct(data);
        setFlavours(data?.flavours);
        setShapes(data?.shapes);
      })
      .catch((err) => {
        toast.error(err.message);
      });
  }, [productId]);

  useEffect(() => {
    const availableColorImages = [
      '/images/colors/color1.jpeg',
      '/images/colors/color2.jpeg',
      '/images/colors/color3.jpeg',
      '/images/colors/color4.jpeg',
      '/images/colors/color5.jpeg',
      '/images/colors/color6.jpeg',
      '/images/colors/color7.jpeg',
      '/images/colors/color8.jpeg',
      '/images/colors/color9.jpeg',
      '/images/colors/color10.jpeg',
      '/images/colors/color11.jpeg',
      '/images/colors/color12.jpeg',
      '/images/colors/color13.jpeg',
      '/images/colors/color14.jpeg',
    ];

    setColorImages(availableColorImages);
  }, []);

  const [index, setIndex] = useState(0);
  const [colorIndex, setColorIndex] = useState(0);

  const handleSelect = (selectedIndex) => {
    setIndex(selectedIndex);
  };

  const handleColorSelect = (selectedIndex) => {
    setColorIndex(selectedIndex);
  };

  return (
    <React.Fragment>
      <ToastContainer />
      <Row className="px-2">
        <Breadcrumb
          navigation={[
            { link: '/cake/home', title: 'Categories' },
            { link: `/cake/sub-categories-display/${categoryId}`, title: 'Sub Categories' },
            { link: `/cake/product-display/${categoryId}/${subCategoryId}`, title: 'Products' },
            { link: '#', title: 'Order' },
          ]}
        />
        <div>
          <Link to={'/cake/home'} className="text-decoration-none">
            <button className="btn app-btn-primary mb-3 me-5">&larr; Back</button>
          </Link>
          <Link to={'/cake/orders'} className="text-decoration-none">
            <button className="btn app-btn-primary mb-3 me-5" style={{ float: 'right' }}>
              Orders
            </button>
          </Link>
        </div>
        <Col lg={4} md={4} xs={12} sm={12} className="mb-4">
          <Carousel className="text-center bg-dark px-4 mb-4" activeIndex={index} onSelect={handleSelect}>
            {Array.isArray(product?.images) ? (
              product?.images?.map((img, index) => {
                return (
                  <Carousel.Item key={index}>
                    <img
                      src={`${process.env.REACT_APP_BASE_URL}/${img}`}
                      className="img-fluid"
                      style={{ padding: '20px' }}
                      alt={product?.name}
                    />
                  </Carousel.Item>
                );
              })
            ) : product?.images ? (
              <Carousel.Item>
                <img
                  src={`${process.env.REACT_APP_BASE_URL}/${product?.images}`}
                  className="img-fluid"
                  style={{ padding: '20px' }}
                  alt={product?.name}
                />
              </Carousel.Item>
            ) : (
              ''
            )}
          </Carousel>
          <span className="d-block px-2">{product?.description}</span>

          {colorImages.length > 0 && (
            <div className="mt-4">
              <h5 className="mb-3 text-center">Colour Swatches</h5>
              <Carousel className="text-center bg-dark px-4" activeIndex={colorIndex} onSelect={handleColorSelect}>
                {colorImages.map((img, index) => (
                  <Carousel.Item key={index}>
                    <img
                      src={img}
                      className="img-fluid"
                      style={{
                        padding: '20px',
                        height: '300px',
                        width: '100%',
                        objectFit: 'contain',
                        borderRadius: '8px'
                      }}
                      alt={`Color option ${index + 1}`}
                    />
                  </Carousel.Item>
                ))}
              </Carousel>
            </div>
          )}
        </Col>

        <Col lg={8} md={8} xs={12} sm={12}>
          <h2>{product?.name}</h2>
          <OrderForm productId={productId} product={product} shapes={shapes} flavours={flavours} />
        </Col>
      </Row>
    </React.Fragment>
  );
};

export default OrderDisplay;
